import { render, staticRenderFns } from "./ProductBoxesContainer.vue?vue&type=template&id=5b833f04&scoped=true"
import script from "./ProductBoxesContainer.vue?vue&type=script&lang=js"
export * from "./ProductBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./ProductBoxesContainer.vue?vue&type=style&index=0&id=5b833f04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b833f04",
  null
  
)

export default component.exports